export const CSV_MAX_ROWS = 500;

// Canonical CSV headers, in order — mirrors the backend's expected row shape
// (campaign-manager ConnectInboxCsvRowPayload / Z_tasks/SG-2118.md).
export const CSV_TEMPLATE_HEADERS = [
  "Email",
  "First Name",
  "Last Name",
  "SMTP Username",
  "SMTP Password",
  "SMTP Host",
  "SMTP Port",
  "IMAP Username",
  "IMAP Password",
  "IMAP Host",
  "IMAP Port",
  "Daily Limit",
  "Warmup Enabled",
  "Warmup Limit",
  "Warmup Increment"
];

// System field options shown in the "Maps to" dropdown for each detected CSV column.
export const SYSTEM_FIELDS = [
  { key: "email", label: "Email address", required: true },
  { key: "firstName", label: "First name" },
  { key: "lastName", label: "Last name" },
  { key: "smtpUsername", label: "SMTP username" },
  { key: "smtpPassword", label: "SMTP password" },
  { key: "smtpHost", label: "SMTP host", required: true },
  { key: "smtpPort", label: "SMTP port", required: true },
  { key: "imapUsername", label: "IMAP username" },
  { key: "imapPassword", label: "IMAP password" },
  { key: "imapHost", label: "IMAP host", required: true },
  { key: "imapPort", label: "IMAP port", required: true },
  { key: "dailyLimit", label: "Daily limit" },
  { key: "warmupEnabled", label: "Warmup enabled" },
  { key: "warmupLimit", label: "Warmup limit" },
  { key: "warmupIncrement", label: "Warmup increment" },
  { key: "ignore", label: "— ignore this column —" }
];

// Exact-match header -> system field key, used for auto-mapping on upload.
export const HEADER_TO_FIELD_KEY = {
  email: "email",
  "first name": "firstName",
  "last name": "lastName",
  "smtp username": "smtpUsername",
  "smtp password": "smtpPassword",
  "smtp host": "smtpHost",
  "smtp port": "smtpPort",
  "imap username": "imapUsername",
  "imap password": "imapPassword",
  "imap host": "imapHost",
  "imap port": "imapPort",
  "daily limit": "dailyLimit",
  "warmup enabled": "warmupEnabled",
  "warmup limit": "warmupLimit",
  "warmup increment": "warmupIncrement"
};

export const REQUIRED_FIELD_KEYS = SYSTEM_FIELDS.filter(
  field => field.required
).map(field => field.key);

export const DEFAULT_ROW_VALUES = {
  dailyLimit: 30,
  warmupEnabled: true,
  warmupLimit: 20,
  warmupIncrement: 2
};

export const MAX_WARMUP_INCREMENT = 4;

// Machine-readable codes paired with each row's failure reason - mirrors
// io.adapt.engage.campaignmanager.constants.ConnectInboxCsvErrorCode on the backend.
// MISSING_FIELD/INVALID_APP_PASSWORD are produced client-side in csvUtils.validateRow();
// everything else comes back from the backend on ConnectInboxCsvRowDetailResponse.errorCode.
export const CONNECT_INBOX_CSV_ERROR_CODE = {
  MISSING_FIELD: "MISSING_FIELD",
  INVALID_APP_PASSWORD: "INVALID_APP_PASSWORD",
  SMTP_AUTH_FAILED: "SMTP_AUTH_FAILED",
  IMAP_AUTH_FAILED: "IMAP_AUTH_FAILED",
  SMTP_UNKNOWN_HOST: "SMTP_UNKNOWN_HOST",
  IMAP_UNKNOWN_HOST: "IMAP_UNKNOWN_HOST",
  SMTP_TIMEOUT: "SMTP_TIMEOUT",
  IMAP_TIMEOUT: "IMAP_TIMEOUT",
  SMTP_CONNECTION_REFUSED: "SMTP_CONNECTION_REFUSED",
  IMAP_CONNECTION_REFUSED: "IMAP_CONNECTION_REFUSED",
  SMTP_SSL_FAILED: "SMTP_SSL_FAILED",
  IMAP_SSL_FAILED: "IMAP_SSL_FAILED",
  SMTP_CONNECTION_FAILED: "SMTP_CONNECTION_FAILED",
  IMAP_CONNECTION_FAILED: "IMAP_CONNECTION_FAILED",
  SMTP_ALREADY_CONNECTED: "SMTP_ALREADY_CONNECTED",
  IMAP_ALREADY_CONNECTED: "IMAP_ALREADY_CONNECTED",
  EMAIL_MISMATCH: "EMAIL_MISMATCH",
  CONNECT_FAILED: "CONNECT_FAILED",
  UNEXPECTED_ERROR: "UNEXPECTED_ERROR"
};

export const BULK_CONNECT_STEPS = {
  CHOOSE: "choose",
  UPLOAD: "upload",
  MAP: "map",
  REVIEW: "review"
};
